import NewHomePage from "../../pages/NewHomepage";
import { ModalProvider } from "../../providers/ModalProvider";
import AuthHomepage from "@/pages/AuthHomepage";
import {useFeatureFlag} from "@/context/FeatureFlagContext";

export const FallbackHomePage = () => {
    const isAuthenticatedInvoicePayAvailable = useFeatureFlag("AUTHENTICATED_INVOICE_PAY");

    return (
      <ModalProvider>
          {
              isAuthenticatedInvoicePayAvailable? <AuthHomepage /> : <NewHomePage />
          }
      </ModalProvider>
    )
  };
